export default "__VITE_ASSET__BjmUeP6k__"